<template>
  <div id="mobile" @mousedown="playAudio">
    <!--顶部浮层-->
    <transition name="moveIn">
      <div class="top-cover" v-show="interfaceShow">
        <div class="join-btn pointer" :class="{'wait-alert': !appInfo.extUrl}" @click="openNewTab(appInfo.extUrl)">招商</div>
        <div class="buy-btn pointer" :class="{'wait-alert': !appInfo.weSiteUrl}" @click="showQr = false">官方商城</div>
        <div class="back-btn pointer" @click="backIndex">
          <img src="../assets/img/pc/home.png" alt="">
          <span> 回首页</span>
        </div>
      </div>
    </transition>
    <div class="qr-wrap" v-show="showQr" @click.stop="showQr = false">
      <div class="qr-box"  @click.stop="">
        <img src="../assets/img/pc/qrpc.png" alt="">
        <div class="close" @click.stop="showQr = false"></div>
      </div>
    </div>

    <!--底部浮层-->
    <!-- <transition name="moveIn">
      <div class="bottom-cover" v-show="interfaceShow"></div>
    </transition> -->

    <!--右侧浮层-->
    <!-- <transition name="fadeIn">
      <div class="right-cover" v-show="interfaceShow"></div>
    </transition> -->

    <!--右侧信息窗-->
    <transition name="moveIn" @enter="showRight">
      <div class="right-info-box" v-show="interfaceShow">
        <div class="right-info">
          <!-- <vue-scroll> -->
            <div class="name-box">
              {{curPano.name}}
            </div>
            <div class="audio-box" v-if="false">
              <div class="aduio-item">
                <div class="audio-btn pointer" :class="{playing: audioInfo.isPlay}" @click="playAudioIntor(!audioInfo.isPlay)"></div>
                <div class="audio-time">
                  <span>{{audioInfo.playedLength}}</span>
                  <span>/</span>
                  <span>{{audioInfo.audioLength}}</span>
                </div>
                <div class="audio-progress">
                  <div class="audio-progress-inner"></div>
                </div>
              </div>
            </div>
            <div class="text-box">
                <vue-scroll>
                  <p v-html="util.formatTextBr(curPano.text)"></p>
                </vue-scroll>
            </div>
            <template v-if="curPano.id === appList.appGroupArray[0].appEntityArray[0].id">
              <div class="btn-box pointer" @click="infoBtnClick">开启四季仙果采摘之旅</div>
            </template>
            <template v-else>
              <div class="btn-box pointer" @click="infoBtnClick" v-if="curPano.extUrl">去购买</div>
              <div class="btn-box btn-back-box pointer" @click="infoBtnClick('back')" v-if="!curPano.extUrl">返回</div>
              <div class="btn-box btn-next-box pointer" @click="infoBtnClick" v-if="!curPano.extUrl">下一个场景</div>
            </template>
          <!-- </vue-scroll> -->
        </div>
      </div>
    </transition>

    <!--音频按钮-->
    <transition name="moveIn">
      <div class="left-btn" v-show="interfaceShow" @click="bgMusicControl()">
        <div class="btn-box">
          <div class="music" :class="{'selected': mainAudioPlay}"></div>
        </div>
      </div>
    </transition>

    <transition name="moveIn">
      <div class="pick-btn pick1" :class="{'selected': picked}" v-show="interfaceShow" @click="pickedClick()">
        <div class="pick"></div>
      </div>
    </transition>
    <transition name="moveIn">
      <div class="main-cover" v-show="interfaceShow && showPicked" @click="showPicked = false">
        <div class="picked-cover" @click.stop="">
          <div class="mobile-title">
            <p>我的果篮</p>
          </div>
          <i class="close-btn" @click="showPicked = false"></i>
          <div class="body">
            <div class="rows row2">
              <div class="item" :class="{'select': pickedJson.includes('caomei')}">
                <img src="../assets/img/mobile/caomei@2x.png" alt="">
              </div>
              <div class="item" :class="{'select': pickedJson.includes('yingtao')}">
                <img src="../assets/img/mobile/yingtao@2x.png" alt="">
              </div>
            </div>
            <div class="rows row3">
              <div class="item" :class="{'select': pickedJson.includes('taozi')}">
                <img src="../assets/img/mobile/taozi@2x.png" alt="">
              </div>
              <div class="item" :class="{'select': pickedJson.includes('yangmei')}">
                <img src="../assets/img/mobile/yangmei@2x.png" alt="">
              </div>
              <div class="item" :class="{'select': pickedJson.includes('putao')}">
                <img src="../assets/img/mobile/putao@2x.png" alt="">
              </div>
            </div>
            <div class="rows row2">
              <div class="item" :class="{'select': pickedJson.includes('lanmei')}">
                <img src="../assets/img/mobile/lanmei@2x.png" alt="">
              </div>
              <div class="item" :class="{'select': pickedJson.includes('mihoutao')}">
                <img src="../assets/img/mobile/mihoutao@2x.png" alt="">
              </div>
            </div>
          </div>
          <div class="text-box">
            以上是你摘到的水果，点击按钮可直接购买送到家
          </div>
          <div class="btn-box" @click="showQr = true">
            基地直购
          </div>
        </div>
      </div>
    </transition>
    <!--logo部分-->
    <!-- <transition name="moveIn">
      <div class="logo-box" v-show="interfaceShow">
        <div class="clearfix">
          <div class="logo" :style="{'background-image': 'url(' +  appInfo.logo + ')'}"></div>
          <span v-if="visitNum > 0"></span>
          <p class="visit-num" v-if="visitNum > 0">{{visitNum}}</p>
        </div>
      </div>
    </transition> -->

    <!--底部按钮-->
    <!-- <transition name="moveIn">
      <div class="bottom-btn-box clearfix" v-if="false" v-show="interfaceShow || markerInfo.display">
        <ul class="btn-box clearfix">
          <li class="btn fl" v-if="false" :class="{'selected': haveOtherPano}">
            <i class="icon album"></i>
            <p class="tip">相册</p>
          </li>
          <li class="btn fl" :class="{'selected': isPageFullScreen}" @click="setPageFullscreen()">
            <i class="icon fullscreen"></i>
            <p class="tip">全屏</p>
          </li>
          <li class="btn fl" :class="{'selected': isLike}" @click="addLike()">
            <i class="icon like"></i>
            <p class="tip">点赞</p>
            <span class="num" v-if="likeNum > 0 && likeNum <= 999">{{likeNum}}</span>
            <span class="num" v-if="likeNum > 999">999+</span>
          </li>
          <li class="btn fl" :class="{'selected': isShowShare}" @click="setShowShare()">
            <i class="icon share"></i>
            <transition name="opacity">
              <div class="share-box" v-show="interfaceShow && isShowShare">
                <div class="qrcode-box" v-show="whichShareBtnSelect === 'wx'">
                  <p class="share-wx">分享到微信</p>
                  <div class="qrcode">
                    <canvas id="canvas"></canvas>
                  </div>
                  <p class="share-tip">用微信“扫一扫”二维码，即可把链接<br>分享给您的微信好友或朋友圈</p>
                </div>
                <div class="share-btn-box clearfix" @click.stop="">
                  <div class="share-btn" :class="{'selected': whichShareBtnSelect === 'wx'}" @click.stop="shareTo('wx')">
                    <div class="wx"></div>
                    <p>微信</p>
                  </div>
                  <div class="share-btn" :class="{'selected': whichShareBtnSelect === 'qq'}" @click.stop="shareTo('qq')">
                    <div class="qq"></div>
                    <p>QQ</p>
                  </div>
                  <div class="share-btn" :class="{'selected': whichShareBtnSelect === 'wb'}" @click.stop="shareTo('wb')">
                    <div class="wb"></div>
                    <p>微博</p>
                  </div>
                </div>
              </div>
            </transition>
            <p class="tip" v-if="!isShowShare">分享</p>
          </li>
          <li class="btn fl" :class="{'selected': mainAudioPlay}" @click="bgMusicControl()">
            <i class="icon music"></i>
            <p class="tip">音乐</p>
          </li>
          <li class="btn fl" :class="{'selected': museumInfoShow}" @click="showMuseumInfo(true)">
            <i class="icon info"></i>
            <p class="tip">信息</p>
          </li>
        </ul>
      </div>
    </transition> -->

    <!--地图蒙层-->
    <transition name="moveIn">
      <!-- toPanoPage -->
      <map-custom :class="{small: !mapFullscreen}" :mapFullscreen="mapFullscreen" v-show="interfaceShow" :activePano='activePano' :mapData="appInfo.map" :allPano="allPano" @customMapMarkerClick="customMapMarkerClick" @closeMapFullscreen="closeMapFullscreen" @showMapFullscreen="showMapFullscreen"></map-custom>
    </transition>

    <!--全景列表-->
    <!-- <div class="pano-list-area" :class="{'show': interfaceShow, 'pano-change': changingPano}">
      <div class="swiper-box">
        <div id="panoListSwiper" class="pano-list-box swiper-container">
          <ul class="swiper-wrapper">
            <li class="swiper-slide" v-for="(id, index) in panoGroup" :key="index" @click="setPano(id)">
              <div class="img-box" :class="{'selected': introPano.panoIndex === index}">
                <img :src="util.getPicUrl(allPano[id].panoInfo.thumbnail, 'imgsmall')" alt="">
                <div class="border"></div>
                <p class="btn-title">{{introPano.baseInfo ? introPano.baseInfo.tags[0] : ''}}</p>
              </div>
              <div class="progress-box" v-show="introPano.panoIndex === index">
                <div class="line" ref="panoListLine"></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="autoplay-btn" :class="{'pause': isRoaming}" @click="todoRoaming(0)"></div>
    </div> -->

    <!--视频蒙层-->
    <transition name="cover">
      <div class="main-cover" v-show="videoFullscreen">
        <div class="box">
          <div class="video-box">
            <video :src="videoUrl" controls></video>
          </div>
          <i class="close-btn" @click="closeMediaFullscreen()"></i>
        </div>
      </div>
    </transition>

    <!--图片蒙层-->
    <transition name="cover">
      <div class="main-cover" v-show="imageFullscreen">
        <div class="box-image-swiper">
          <div id="imageSwiper" class="image-swiper-box swiper-container">
            <ul class="swiper-wrapper">
              <li class="swiper-slide" v-for="(img, index) in imageSwiperList" :key="index">
                <img :src="img" alt="">
              </li>
            </ul>
            <div class="swiper-pagination" v-show="imageSwiperList.length > 1"></div>
            <div class="swiper-button-prev"></div><!--左箭头-->
            <div class="swiper-button-next"></div><!--右箭头-->
          </div>
          <i class="close-btn" @click="closeMediaFullscreen()"></i>
        </div>
      </div>
    </transition>

    <!--购买二维码弹层-->
    <transition name="cover">
      <div class="buy-page" v-show="buyPageShow">
        <div class="qrback">
          <img class="qrcode" :src="buyPageQRCode" alt="">
          <div class="close-btn" @click="closeBuyPage"></div>
        </div>
      </div>
    </transition>

    <!--溯源查询页-->
    <transition name="cover">
      <div class="search-page-cover" v-show="searchPageShow">
        <div class="mobile-title">
          <p>溯源查询</p>
          <div class="close-btn" @click="searchPageShow = false"></div>
        </div>
        <div class="scroll-box">
          <img class="banner" src="../assets/img/temp/banner.png" alt="">
          <img class="list" src="../assets/img/temp/list.png" alt="">
        </div>
      </div>
    </transition>

    <!--富文本蒙层-->
    <!-- <transition name="cover">
      <div class="main-cover" v-show="iframeFullscreen">
        <div class="box">
          <div class="iframe-box">
            <iframe v-if="iframeUrl" :src="iframeUrl"></iframe>
          </div>
          <i class="close-btn" @click="closeMediaFullscreen()"></i>
        </div>
      </div>
    </transition> -->

    <!--展览信息蒙层-->
    <!-- <transition name="cover">
      <div class="museum-cover" v-show="museumInfoShow">
        <swiper class="area" :options="museumInfoSwiperOptions">
          <swiper-slide class="box">
            <div class="logo"></div>
            <ul class="intro">
              <li>
                <h3>展览介绍</h3>
                <h4 style="text-align: justify;" v-html="util.formatTextBr(appInfo.description)"></h4>
              </li>
              <li>
                <h3>展期</h3>
                <h4>常设展览</h4>
              </li>
              <li>
                <h3>地点</h3>
                <h4>北京首都机场辅路民航200号</h4>
              </li>
              <li>
                <h3>主办单位</h3>
                <h4>民航博物馆</h4>
              </li>
              <li>
                <h3>协办单位</h3>
                <h4>民航华北地区管理局 民航东北地区管理局 </h4>
                <h4>民航华东地区管理局 民航中南地区管理局</h4>
                <h4>民航西南地区管理局 民航西北地区管理局</h4>
                <h4>民航新疆管理局 民航宣传教育中心</h4>
              </li>
            </ul>
          </swiper-slide>
          <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
        <i class="close-btn" @click="showMuseumInfo(false)"></i>
      </div>
    </transition> -->

    <!--三维marker图文信息-->
    <!--<model-page-->
      <!--ref="markerInfoRef"-->
      <!--v-show="markerInfo.display"-->
      <!--:show="markerInfo.display"-->
      <!--:info="markerInfo.info"-->
      <!--:appInfo="appInfo"-->
      <!--:visitNum="visitNum"-->
      <!--:likeNum="likeNum"-->
      <!--:mainAudioPlay="mainAudioPlay"-->
      <!--:isLike="isLike"-->
      <!--:isShowShare="isShowShare"-->
      <!--@close="showModel(false)"-->
    <!--&gt;</model-page>-->

    <!--纯图片marker图文信息-->
    <transition name="cover">
      <image-page
        ref="markerInfoRef"
        v-show="markerInfo.display"
        :APPID="APPID"
        :show="markerInfo.display"
        :info="markerInfo.info"
        :appInfo="appInfo"
        :visitNum="visitNum"
        :likeNum="likeNum"
        :mainAudioPlay="mainAudioPlay"
        :isLike="isLike"
        :isShowShare="isShowShare"
        @close="closeImagePage">
      </image-page>
    </transition>

    <!--漫游蒙层-->
    <div class="roaming-cover" v-show="isRoaming" @click.stop="stopRoaming"></div>

    <!--欢迎页-->
    <transition name="fade">
      <wel-page v-show="mainCoverShow" :appInfo='appInfo'  :url="appInfo.pcCover" :isEnter="!mainCoverShow" @runEnter="runEnter(false)" @showMap="showMyMap" @showSearchPage="showSearchPage"></wel-page>
    </transition>

    <!--loading-->
    <!-- <div class="loading-box" v-show="changingPano">
      <div class="loading-icon-back">
        <div class="loading-icon"></div>
      </div>
    </div> -->
  </div>
</template>

<script>
// import comment from './components/comment'
import welPage from './components/welPage'
import imagePage from './components/imagePage'
import customMap from '../components/customMap'
// import modelPage from './components/modelPage'

export default {
  name: 'App',
  components: {
    // 'comment': comment,
    'wel-page': welPage,
    'image-page': imagePage,
    'map-custom': customMap
    // 'model-page': modelPage
  },
  data () {
    return {
      showQr: false,
      showPicked: false,
      pickedJson: [],
      // APPID: '6037',
      picked: false,
      APPID: '',
      bgVolume: 1,
      activePano: {},
      time: null, // 定时器暂存
      audioInfo: {
        playedLength: '00:00',
        audioLength: '00:00',
        isPlay: false
      }, // 音频信息  用于右侧显示
      audioFirstPlay: true,
      // 开关
      interfaceShow: false, // 界面显示开关
      cardFullscreen: false, // 是否显示全屏内容
      mapFullscreen: false, // 地图全屏内容
      videoFullscreen: false, // 视频全屏内容
      iframeFullscreen: false, // 富文本全屏内容
      imageFullscreen: false, // 图片全屏内容
      isPageFullScreen: false, // 页面是否全屏
      mainCoverShow: false, // 欢迎页显示开关
      contentCardsShow: true, // 主卡片显示开关
      willExpand: false, // 卡片即将展开指示器
      isShowShare: false, // 是否展示分享盒子开关
      locationListShow: false, // 地图内列表展示开关
      mainAudioPlay: false, // 主音频播放开关
      audioPlayTemp: false, // 音频是否播放暂存器
      infoCardsShow: false, // 二级页详情卡片开关
      markerInfoFullscreen: false, // 图文marker展示开关
      panoIntroShow: true, // 图文信息展示
      panoIntroShowAll: false, // 图文信息全屏
      haveOtherPano: false, // 是否有其他全景
      museumInfoShow: false, // 展览信息蒙层
      audioDomIsPlaying: false,
      isRoaming: false,
      panoInfoCoverShow: false,
      changingPano: false, // 正在切换全景
      searchPageShow: false,
      whichShareBtnSelect: 'wx', // 哪一个分享按钮被选中
      // 数据
      appList: {
        appGroupArray: [{
          appEntityArray: [{
            name: ''
          }]
        }]
      },
      appInfo: {},
      visitNum: 0,
      likeNum: 0,
      isLike: false,
      videoUrl: '',
      iframeUrl: '',
      allPano: {},
      curPano: {
        id: '',
        level: 1,
        name: ''
      },
      introPano: {
        id: '',
        level: 1,
        name: '',
        baseInfo: null,
        maxIntro: [],
        panoIndex: 0
      },
      panoGroup: [],
      mapSelected: '',
      otherPanoArray: [],
      groupPlugins: {},
      curPanoNorthHeading: 0,
      markerHeadingDifference: 0,
      // 操作数据缓存
      touchDown: false,
      touchLeft: 0,
      k: 0, // 屏幕大小变换时，暂存timeout
      imageSwiperList: [],
      markerInfo: {
        title: '',
        imgUrl: '',
        content: '',
        display: false,
        info: null
      },
      pixelRatio: 1,
      comment: '',
      roamingTime: null,
      panoListLineInter: null,
      isDoingSwiper: false,
      museumInfoSwiperOptions: {
        direction: 'vertical',
        initialSlide: 0,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        freeMode: true,
        slidesPerView: 'auto',
        mousewheelControl: true,
        scrollbar: '.swiper-scrollbar'
      },
      isViewJson: {},
      buyPageShow: false,
      buyPageQRCode: ''
    }
  },
  // watch: {
  //   'activePano.audioIntro': function (val, oldval) {
  //     this.setAudio(val)
  //   }
  // },
  mounted () {
    if (this.util.isMobile()) {
      let url = location.href
      let url1 = url.replace('indexpc.html', 'index.html')
      location.href = url1
      return false
    }
    if (this.util.getUrlParam('appId')) {
      this.APPID = '' + this.util.getUrlParam('appId')
    } else {
      this.APPID = '2004173594'
    }
    window.QRCode.toCanvas(document.getElementById('canvas'), location.href, {
      'width': 96
    })
    window.markerArray = []
    window.mapMarkerArray = []
    this.axios.all([
      this.$api.getAppList(this.APPID),
      this.$api.getAppInfo(this.APPID)
    ]).then(this.axios.spread((appList, appInfo) => {
      this.appList = appList.data.data
      this.appInfo = appInfo.data.data
      this.util.setWechartTitle(this.appInfo.name)
      this.util.addStatistics(this.appInfo.statId, this.appInfo.statCid)
      !this.appInfo.pcCover && (this.appInfo.pcCover = '//tiles.pano.vizen.cn/5a1fa30026d67f25359f0a6c/sphere/thumb_360.jpg')
      !this.appInfo.cover && (this.appInfo.cover = '//tiles.pano.vizen.cn/5a1fa30026d67f25359f0a6c/sphere/thumb_360.jpg')
      this.formatData()
      this.initEngine()
      this.setAudio(this.appInfo.bgAudioUrl)
      this.mainCoverShow = true
      this.appInfo.map = this.initCustomMap(this.appInfo.map)
      window.hideVizenLoading()
    }))
    // this.watchMusicReady()
    // this.watchMusicTime()
    // this.getLikeAndVisit()
    // this.addVisit()
    // this.couldLike()

    // /* eslint-disable-next-line */
    // window.cardSwiper = new window.Swiper('#panoListSwiper', {
    //   direction: 'vertical',
    //   initialSlide: 0,
    //   observer: true, // 修改swiper自己或子元素时，自动初始化swiper
    //   observeParents: true, // 修改swiper的父元素时，自动初始化swiper
    //   freeMode: true,
    //   slidesPerView: 'auto'
    // })
    // /* eslint-disable-next-line */
    // window.imageSwiper = new window.Swiper('#imageSwiper', {
    //   direction: 'horizontal',
    //   initialSlide: 0,
    //   observer: true, // 修改swiper自己或子元素时，自动初始化swiper
    //   observeParents: true, // 修改swiper的父元素时，自动初始化swiper
    //   pagination: '.swiper-pagination',
    //   prevButton: '.swiper-button-prev',
    //   nextButton: '.swiper-button-next'
    // })

    document.querySelector('body').addEventListener('mouseup', () => {
      if (this.isDoingSwiper) {
        window.pano.touchable = true
        this.isDoingSwiper = false
      }
    })
  },
  methods: {
    showMapFullscreen () {
      if (!this.mapFullscreen) {
        this.mapFullscreen = !this.mapFullscreen
        document.querySelector('.full-map-cove').style.transform = 'scale(1)'
      }
    },
    showRight () {
      window.fnResize()
    },
    openNewTab (url) {
      if (url) {
        window.open(url)
      }
    },
    // 首次点击时触发音乐播放
    playAudio () {
      if (this.audioFirstPlay) {
        document.getElementById('audioDom').play()
        this.audioFirstPlay = false
      }
    },
    customMapMarkerClick (marker) {
      // if (marker.type = 'entity') {
      //   this.toPanoPage(marker.properties.entityId)
      // } else {
      // }
      this.toPanoPage(marker.properties.facilityId)
    },
    // 设置分享
    setShare () {
      let shareUrl = null
      let shareTitle = this.appInfo.shareTitle
      let shareDesc = this.appInfo.shareDesc
      let shareImg = this.util.checkImageUrl(this.appInfo.logo || this.appInfo.thumbnail)
      window.getShareInfoSub(shareUrl, shareTitle, shareDesc, shareImg)
    },
    // 初始化引擎
    initEngine () {
      let container = document.getElementById('appContainer')
      window.pano = new window.vizengine.PanoView(container)
      window.pano.setOnClick(() => {
        this.isShowShare = false
        this.interfaceShow = !this.interfaceShow
        this.showMarker(this.interfaceShow)
        // this.window.panoClickLogic()
      })
      let panoInfo = this.allPano[this.panoGroup[0]].panoInfo
      panoInfo.facilityId = this.allPano[this.panoGroup[0]].facilityId
      this.activePano = panoInfo
      let panoId = panoInfo.panoId
      if (this.util.env().testEnv) {
        panoId = '[TT]' + panoId
      }
      window.pano.setPanoIdAndFilterName(panoId, '', () => {
        window.pano.setHeading(panoInfo.heading || 0)
        window.pano.setPitch(panoInfo.pitch || 0)
        this.util.panoInter(true)
      })
      // this.interfaceShow = true
      this.setPanorequestDraw()
    },
    backIndex () {
      this.closeMapFullscreen()
      let panoInfo = this.allPano[this.panoGroup[0]].panoInfo
      panoInfo.facilityId = this.allPano[this.panoGroup[0]].facilityId
      // this.util.setPano(panoInfo, panoInfo.heading)
      this.curPano = this.allPano[this.panoGroup[0]]
      this.activePano = panoInfo
      this.setPano(this.panoGroup[0], panoInfo.id, '', () => {
        setTimeout(() => {
          this.setInterface(false)
          this.util.panoInter(false)
          this.mainCoverShow = true
          window.pano.setAutoPlayEnable(true)
        }, 300)
      })
    },
    // 进入全景
    runEnter () {
      this.mainCoverShow = false
      setTimeout(() => {
        this.setInterface(true)
        this.util.panoInter(true)
      }, 100)
      // 当前焦点全景
      this.setPano(this.panoGroup[0])
      let panoInfo = this.allPano[this.panoGroup[0]].panoInfo
      panoInfo.facilityId = this.allPano[this.panoGroup[0]].facilityId
      this.curPano = this.allPano[this.panoGroup[0]]
      this.activePano = panoInfo
    },
    showMyMap () {
      this.mainCoverShow = false
      setTimeout(() => {
        this.setInterface(true)
        this.util.panoInter(true)
      }, 100)
      // 当前焦点全景
      this.setPano(this.panoGroup[0])
      let panoInfo = this.allPano[this.panoGroup[0]].panoInfo
      panoInfo.facilityId = this.allPano[this.panoGroup[0]].facilityId
      this.curPano = this.allPano[this.panoGroup[0]]
      this.activePano = panoInfo
      this.mapFullscreen = true
    },
    // 设置全景
    setPano (id, panoId, type, callback) {
      let that = this
      if (panoId) {
        if (that.curPano.id === id && that.curPano.panoId === panoId) {
          callback && callback()
          return
        }
      } else {
        if (that.curPano.id === id) {
          callback && callback()
          return
        }
      }
      if (that.interfaceShow) {
        that.changingPano = true
      }
      let panoIndex = 0
      // 卡片内容处理

      // 数据处理操作
      let tempFun = () => {
        if (type === 'marker') {
          window.pano.setFov(100)
        }
        if (!that.panoIntroShowAll) {
          that.setInterface(true)
          that.util.panoInter(true)
        }
        that.addMarker(id, panoIndex)
        that.changingPano = false
        // window.pano.setAutoPlayEnable(false)
        callback && callback()
      }

      // 场景转换和获取基本信息
      let setNewPanoHeading = () => {
        let newPanoHeading = null
        // 设置当前焦点全景
        that.allPano[id].isView = true
        that.curPano = that.allPano[id]
        that.activePano = that.curPano
        that.curPanoNorthHeading = that.curPano.panoInfo.heading
        newPanoHeading = that.curPano.panoInfo.heading
        // that.setMiniMapRotate(that.getPanoNorthHeading(that.curPano.facilityId))
        // 场景转换
        that.util.setPano(that.curPano.panoInfo, newPanoHeading, tempFun)
      }

      // 是否已存在marker信息，没有时去获取
      let willGetPanoMarker = () => {
        if (that.allPano[id].markerInfo === null) {
          that.$api.getPanoMarker({ facilityId: that.allPano[id].facilityId, materialId: that.allPano[id].panoArray[0].materialId }).then(res => {
            that.allPano[id].markerInfo = res.data.data
            setNewPanoHeading()
          })
        } else {
          setNewPanoHeading()
        }
      }

      // 最先执行
      if (type === 'marker') {
        willGetPanoMarker()
      } else {
        setTimeout(() => {
          willGetPanoMarker()
        }, 800)
      }
    },

    initCustomMap (data) {
      if (!data) {
        return data
      }
      data.marker.forEach((item) => {
        item.left = parseFloat(item.abscissa)
        item.top = parseFloat(item.ordinate)
        item.defaultOrientation = item.orientation || 0
        let id = ''
        if (item.type === 'facility') {
          id = item.facilityId
        } else {
          id = item.entityId
        }
        if (this.allPano[id].tags[0] === '重点') {
          item['mapType'] = 1
        } else {
          item['mapType'] = 0
        }
      })
      return data
    },
    // 处理数据
    formatData () {
      // 整理应用结构，六层结构，逐级循环
      this.appList.appGroupArray.forEach((appGroupEle, appGroupIdx) => {
        appGroupEle.appEntityArray.forEach((appEntityEle, appEntityIdx) => {
          this.allPano[appEntityEle.id] = this.util.initData(appEntityEle, 1)
          this.allPano[appEntityEle.id]['markerInfo'] = null
          this.allPano[appEntityEle.id]['maxIntro'] = []
          this.allPano[appEntityEle.id]['panoIndex'] = appGroupIdx
          this.allPano[appEntityEle.id]['type'] = appEntityEle.type
          this.allPano[appEntityEle.id]['text'] = appEntityEle.description
          this.allPano[appEntityEle.id]['extUrl'] = appEntityEle.extUrl
          this.allPano[appEntityEle.id]['audioIntro'] = appEntityEle.audioIntro
          this.allPano[appEntityEle.id]['tags'] = appEntityEle.tags ? appEntityEle.tags : []
          this.panoGroup.push(appEntityEle.id)
          let facilityArray = []
          let entityArray = []
          appEntityEle.groupArray.forEach((groupEle, groupIdx) => {
            groupEle.materialArray.forEach((materialEle, materialIdx) => {
              this.allPano[materialEle.id] = this.util.initData(materialEle, 2)
              this.allPano[materialEle.id]['markerInfo'] = null
              this.allPano[materialEle.id]['parentId'] = appEntityEle.id
              this.allPano[materialEle.id]['type'] = materialEle.type
              this.allPano[materialEle.id]['text'] = materialEle.intro
              this.allPano[materialEle.id]['extUrl'] = materialEle.extUrl
              this.allPano[materialEle.id]['audioIntro'] = materialEle.audioIntro
              this.allPano[materialEle.id]['tags'] = materialEle.tags ? materialEle.tags : []
              this.panoGroup.push(materialEle.id)
              if (materialEle.type === 'facility') {
                facilityArray.push(materialEle.id)
              }
              if (materialEle.type === 'entity') {
                entityArray.push(materialEle.id)
              }
            })
          })
          this.allPano[appEntityEle.id]['entityArray'] = entityArray
          this.allPano[appEntityEle.id]['facilityArray'] = facilityArray
        })
      })
      console.log(this.allPano)
    },
    // 重置全景宽高，避免横竖屏显示bug
    setPanorequestDraw () {
      window.addEventListener('resize', () => {
        clearTimeout(this.k)
        this.k = setTimeout(() => {
          window.pano.requestDraw()
        }, 300)
      }, false)
    },
    // 监听音乐实时播放的时间
    watchMusicTime () {
      let audio = document.getElementById('audioDom')
      let self = this
      audio.addEventListener('timeupdate', () => {
        self.audioInfo.playedLengthNum = parseInt(audio.currentTime) || 0
        self.audioInfo.playedLength = self.util.translateDurationToShow(parseInt(audio.currentTime), 1) || '00:00'
        function toPercent (point) {
          var str = Number(point * 100).toFixed(1)
          str += '%'
          return str
        }
        document.querySelector('.audio-progress-inner').style.width = toPercent(self.audioInfo.playedLengthNum / self.audioInfo.audioLengthNum)
      })
    },
    unWatchMusicTime () {
      let audio = document.getElementById('audioDom')
      audio.addEventListener('timeupdate', () => {
      })
    },
    watchMusicReady () {
      let audio = document.getElementById('audioDom')
      let self = this
      audio.oncanplay = function () {
        self.audioInfo.audioLengthNum = audio.duration || 200
        self.audioInfo.audioLength = self.util.translateDurationToShow(parseInt(audio.duration), 1) || '00:00'
      }
      audio.onended = function () {
        self.audioInfo.playedLength = '00:00'
        self.audioInfo.isPlay = false
      }
    },
    // 播放音频
    playAudioIntor (type) { // true 表示开始自动播放 false关闭
      let audioDom = document.getElementById('audioDom')
      if (type) {
        this.audioInfo.isPlay = true
        audioDom.play()
      } else {
        this.audioInfo.isPlay = false
        audioDom.pause()
      }
    },
    // 设置音频
    // setAudio (url, autoplay = true) {
    //   if (!url) {
    //     this.mainAudioPlay = false
    //     return
    //   }
    //   let url1 = this.util.setProtocol(url)
    //   let audioDom = document.getElementById('audioDom')
    //   if (url1 === audioDom.src) {
    //     return
    //   }
    //   audioDom.setAttribute('src', url1)
    //   if (autoplay || this.mainAudioPlay) {
    //     this.mainAudioPlay = true
    //     audioDom.play()
    //   }
    // },
    // 设置音频
    setAudio (url) {
      if (!url) {
        this.mainAudioPlay = false
        return
      }
      let url1 = this.util.setProtocol(url)
      let audioDom = document.getElementById('audioDom')
      if (url1 === audioDom.src) {
        return
      }
      audioDom.setAttribute('src', url1)
      this.mainAudioPlay = true
      setTimeout(() => {
        audioDom.play()
      }, 300)
    },
    pickedClick () {
      this.showPicked = true
    },
    // 背景音乐控制
    bgMusicControl () {
      let audioDom = document.getElementById('audioDom')
      // document.getElementById('introAudioDom').pause()
      // this.infoAudioPlay = false
      if (this.mainAudioPlay) {
        audioDom.pause()
        this.mainAudioPlay = false
      } else {
        audioDom.play()
        this.mainAudioPlay = true
      }
    },

    infoBtnClick (to) {
      if (to === 'back') {
        let index = this.panoGroup.findIndex((item) => {
          return item === this.curPano.id
        })
        if ((index - 1) <= 0) {
          index = 0
        } else {
          index = index - 1
        }
        this.setPano(this.panoGroup[index])
      } else {
        if (this.curPano.extUrl) {
          window.open(this.curPano.extUrl)
        } else {
          let index = this.panoGroup.findIndex((item) => {
            return item === this.curPano.id
          })
          if ((index + 1) > this.panoGroup.length) {
            index = 0
          } else {
            index = index + 1
          }
          this.setPano(this.panoGroup[index])
        }
      }
    },
    // 播放富媒体，视频、富文本
    showMedia (data) {
      this.willPlayOthers()
      this.util.panoInter(false)
      this.setInterface(false)
      if (this.cardFullscreen) {
        this.$refs.cards.$el.style.opacity = '0'
      }
      if (data.type === 'video') {
        this.videoUrl = data.url
        this.videoFullscreen = true
      } else if (data.type === 'iframe' || data.type === 'url') {
        window.open(data.url)
        this.util.panoInter(true)
        this.setInterface(true)
        this.othersPlayDone()
        // this.iframeUrl = data.url
        // this.iframeFullscreen = true
      } else if (data.type === 'image') {
        this.imageSwiperList = data.array
        window.imageSwiper.update()
        window.imageSwiper.slideTo(data.index, 0, false)
        this.imageFullscreen = true
      } else if (data.type === 'markerInfo') {
        this.markerInfo.title = data.data.name
        this.markerInfo.imgUrl = data.data.properties.pic
        this.markerInfo.content = data.data.properties.content
        this.markerInfoFullscreen = true
      }
    },
    // 关闭富媒体弹窗
    closeMediaFullscreen () {
      this.videoFullscreen = false
      this.iframeFullscreen = false
      this.imageFullscreen = false
      this.markerInfoFullscreen = false
      if (!this.cardFullscreen) {
        this.setInterface(true)
        setTimeout(() => {
          this.util.panoInter(true)
          this.othersPlayDone()
        }, 800)
      } else {
        this.$refs.cards.$el.style.opacity = '1'
      }
      this.videoUrl = ''
      this.iframeUrl = ''
    },
    // 即将播放其他内容，停止音频
    willPlayOthers () {
      let audioDom = document.getElementById('audioDom')
      // let audioBgDom = document.getElementById('audioBgDom')
      this.audioPlayTemp = this.mainAudioPlay
      if (this.mainAudioPlay) {
        audioDom.pause()
        // audioBgDom.pause()
        this.mainAudioPlay = false
      }
    },
    // 其他内容播放完毕，重新播放音频
    othersPlayDone () {
      let audioDom = document.getElementById('audioDom')
      // let audioBgDom = document.getElementById('audioBgDom')
      if (this.audioPlayTemp) {
        audioDom.play()
        // audioBgDom.play()
        this.mainAudioPlay = true
      }
    },
    // 带有动画效果的全景跳转
    setAnimationChangePano (data, type) {
      if (this.interfaceShow) {
        this.changingPano = true
      }
      this.markerHeadingDifference = this.curPanoNorthHeading - data.heading
      this.util.startNewPanoAnimation({
        panoView: window.pano,
        toHeading: data.heading,
        // toPitch: data.pitch || window.pano.getPitch(),
        toPitch: 0,
        type: type,
        callback: () => { this.setPano(data.id, data.properties.panoId, 'marker') }
      })
    },
    clickPick (dom, marker) {
      if (marker.name.split('-').length < 2) {
        return
      }
      switch (marker.name.split('-')[1]) {
        case '草莓':
          if (!this.pickedJson.includes('caomei')) {
            this.pickedJson.push('caomei')
          }
          break
        case '葡萄':
          if (!this.pickedJson.includes('putao')) {
            this.pickedJson.push('putao')
          }
          break
        case '猕猴桃':
          if (!this.pickedJson.includes('mihoutao')) {
            this.pickedJson.push('mihoutao')
          }
          break
        case '蓝莓':
          if (!this.pickedJson.includes('lanmei')) {
            this.pickedJson.push('lanmei')
          }
          break
        case '杨梅':
          if (!this.pickedJson.includes('yangmei')) {
            this.pickedJson.push('yangmei')
          }
          break
        case '桃子':
          if (!this.pickedJson.includes('taozi')) {
            this.pickedJson.push('taozi')
          }
          break
        case '樱桃':
          if (!this.pickedJson.includes('yingtao')) {
            this.pickedJson.push('yingtao')
          }
          break
      }
      this.picked = true
      let domId = 'pickImg' + marker.id
      document.getElementById(domId).querySelector('img').style.width = 0
      document.getElementById(domId).querySelector('img').style.height = 0
      document.getElementById(domId).style.width = 0
      document.getElementById(domId).style.height = 0
      setTimeout(() => {
        document.querySelector('.pick-btn').classList.add('selected2')
        setTimeout(() => {
          document.querySelector('.pick-btn').classList.remove('selected2')
        }, 500)
      }, 30)
    },
    // 添加marker
    addMarker (id, index) {
      window.pano.clearMarkers()
      window.markerArray = []
      let mks = this.allPano[id].markerInfo.marker
      if (!mks || mks.length === 0) {
        return
      }
      for (var i = 0; i < mks.length; i++) {
        // 识别特殊marker 正北方向marker
        if (mks[i].type === 'info' && mks[i].name === '正北方向') {
          this.curPanoNorthHeading = mks[i].heading
          // this.setMiniMapRotate(this.curPanoNorthHeading)
          continue
        }
        // marker
        let marker = this.util.markerWraper(mks[i])
        if (mks[i].type === 'pano' && !mks[i].name.includes('采摘-')) {
          marker.innerHTML = `<div class="pano-change-marker movingNormal" style="cursor: pointer; text-aline:center">
                                <img style="width: 98px; height: 36px; margin: auto;display: block;" src="${mks[i].url}">
                                <p style="font-size:18px; color:rgba(244,252,249,1); margin-top: 12px; text-align: center;">${mks[i].name}</p>
                              </div>`
          let data = mks[i]
          if (mks[i].properties.entityId) {
            if (this.allPano[mks[i].properties.entityId]) {
              data['id'] = mks[i].properties.entityId
              marker.onclick = (e) => {
                this.setAnimationChangePano(data, 'enlarge')
                e.preventDefault()
                e.stopPropagation()
              }
            }
          } else {
            if (this.allPano[mks[i].properties.facilityId]) {
              data['id'] = mks[i].properties.facilityId
              marker.onclick = (e) => {
                this.setAnimationChangePano(data, 'enlarge')
                e.preventDefault()
                e.stopPropagation()
              }
            }
          }
        }

        if (mks[i].type === 'pano' && mks[i].name.includes('采摘-')) {
          marker.innerHTML = `<div id="pickImg${mks[i].id}" class="pano-change-marker movingNormal" style="cursor: pointer; text-aline:center">
                                <img style="width: 104px; height: 104px; margin: auto;display: block;" src="${mks[i].url}">
                              </div>`
          let mk = mks[i]
          marker.onclick = (e) => {
            this.clickPick(e, mk)
          }
        }

        // 三维marker
        // let bigWidth = 115 * this.pixelRatio + 'px'
        // let bigHeight = 98 * this.pixelRatio + 'px'
        // let smallWidth = 69 * this.pixelRatio + 'px'
        // let smallHeight = 73 * this.pixelRatio + 'px'
        if (mks[i].type === 'info' && mks[i].properties.pic) {
          // let thumbnail = mks[i].properties.modelInfo.thumbnail
          // let thumbnail = mks[i].properties.pic
          // marker.style.width = bigWidth
          // marker.style.heading = bigHeight
          marker.innerHTML =
            '<div class="marker-line big">' +
            '<p class="title">立即购买</p>' +
            '<div class="bottom"></div>' +
            '</div>'
          marker.anchorY = 0.5 // 设置锚点的纵坐标(0-1,0表示最上，1表示最下)

          let mk = mks[i]
          marker.onclick = () => {
            this.showBuyAlertPage(mk.properties.pic)
            // this.openNewTab(mk.properties.content)
          }
        }
        if (mks[i].type === 'threeDModel') {
          // let thumbnail = mks[i].properties.modelInfo.thumbnail
          let thumbnail = '//cimg.vizen.cn/release/pic/0fe13b8db6285b258f3d27f6cdc7ed66.png/imgsmall'
          // marker.style.width = bigWidth
          // marker.style.heading = bigHeight
          marker.innerHTML =
            '<div class="marker-line big">' +
            '<p class="title">' + mks[i].name + '</p>' +
            '<div class="img-box">' +
            '<img src="' + thumbnail + '" alt="">' +
            '<img class="icon" src="' + require('../assets/img/pc/icon-threeD.png') + '" alt="">' +
            '</div>' +
            '<div class="line"></div>' +
            '<div class="circle"></div>' +
            '</div>'
          marker.anchorY = 1 // 设置锚点的纵坐标(0-1,0表示最上，1表示最下)

          let mk = mks[i]
          marker.onclick = () => {
            this.showImagePage(mk, 'threeDModel')
          }
        }
        if (mks[i].type === 'video') {
          let thumbnail = mks[i].properties.coverImgUrl
          marker.innerHTML =
            '<div class="marker-line video" style="transform: rotate3d(1,0,0,20deg);">' +
            '<img src="' + thumbnail + '" alt="">' +
            '</div>' +
            '<div class="video-bottom"></div>'

          let mk = mks[i]
          marker.onclick = () => {
            this.showMedia({ url: mk.properties.url, type: 'video' })
          }
        }
        window.pano.addMarker(marker)
        window.markerArray.push(marker)
      }
    },
    // 隐藏marker
    showMarker (boo) {
      window.pano.clearMarkers()
      if (boo) {
        window.markerArray.forEach((el) => {
          window.pano.addView(el)
        })
      }
    },
    // 获取喜欢数和浏览数
    getLikeAndVisit () {
      this.$api.getAppZanNum(this.APPID).then(res => {
        this.visitNum = res.data.data.visitCount
        this.likeNum = res.data.data.thumbUpCount
      })
    },
    // 添加浏览数
    addVisit () {
      this.$api.getVisitCount({ 'appId': this.APPID })
    },
    // 是否已喜欢
    couldLike () {
      this.$api.getThumbUpStatus({ 'appId': this.APPID }).then(res => {
        this.isLike = res.data.data
      })
    },
    // 添加喜欢数
    addLike () {
      if (!this.isLike) {
        this.isLike = true
        this.$api.getThumbUpCount({ 'appId': this.APPID }).then(res => {
          if (res.data.code === '0') {
            this.likeNum = this.likeNum + 1
          } else {
            this.isLike = false
          }
        })
      }
    },
    // 设置界面开关
    setInterface (show) {
      this.interfaceShow = show
      this.showMarker(show)
    },
    // 页面全屏
    setPageFullscreen () {
      if (this.isPageFullScreen) {
        this.exitFullscreen()
      } else {
        this.launchFullscreen()
      }
    },
    // 进入全屏逻辑
    launchFullscreen () {
      let el = document.documentElement
      let rfs = el.requestFullScreen || el.webkitRequestFullScreen ||
        el.mozRequestFullScreen || el.msRequestFullScreen
      if (rfs) { // typeof rfs != "undefined" && rfs
        rfs.call(el)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        // for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
        let wscript = new window.ActiveXObject('WScript.Shell')
        if (wscript != null) {
          wscript.SendKeys('{F11}')
        }
      }
      this.isPageFullScreen = true
    },
    // 退出全屏逻辑
    exitFullscreen () {
      let el = document
      let cfs = el.cancelFullScreen || el.webkitCancelFullScreen ||
        el.mozCancelFullScreen || el.exitFullScreen
      if (cfs) { // typeof cfs != "undefined" && cfs
        cfs.call(el)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        // for IE，这里和fullScreen相同，模拟按下F11键退出全屏
        let wscript = new window.ActiveXObject('WScript.Shell')
        if (wscript != null) {
          wscript.SendKeys('{F11}')
        }
      }
      this.isPageFullScreen = false
    },
    // 显示全屏地图
    showMap () {
      // this.util.panoInter(false)
      // this.setInterface(false)
      this.mapFullscreen = true
    },
    // 退出全屏展示
    closeMapFullscreen () {
      if (this.mapFullscreen) {
        this.mapFullscreen = false
        document.querySelector('.full-map-cove').style.transform = 'scale(0.24)'
      }
    },
    // 显示隐藏地图列表
    showLocationList () {
      this.locationListShow = !this.locationListShow
    },
    // 二级卡片操作
    handleTouchStart (event) {
      this.touchDown = true
      // this.setInterface(false)
      this.util.panoInter(false)
      this.touchTop = event.touches[0].clientY
      this.$refs.introTouchArea.style.transition = 'none'
    },
    handleTouchMove (event) {
      if (this.touchDown) {
        let touchMoveTop = event.touches[0].clientY - this.touchTop
        this.$refs.introTouchArea.style.transform = 'translateY(' + touchMoveTop + 'px)'
      }
    },
    handleTouchEnd (event) {
      if (this.touchDown) {
        this.touchDown = false
        this.$refs.introTouchArea.style.transition = 'all 0.6s'
        let touchMoveY = event.changedTouches[0].clientY - this.touchTop
        if (touchMoveY > -60) {
          this.util.panoInter(true)
          this.$refs.introTouchArea.style.transform = 'translateY(0)'
        } else {
          this.setPanoIntroShowAll(true)
          this.$refs.introTouchArea.style.opacity = '0'
          setTimeout(() => {
            this.$refs.introTouchArea.removeAttribute('style')
            this.setInterface(false)
          }, 600)
        }
      }
    },
    sendComment () {
      if (this.comment) {
        this.$refs.comment.pushNewComment(this.comment)
        this.comment = ''
        setTimeout(() => {
          this.commentInputShow = false
        }, 0)
      } else {
        this.commentInputShow = false
      }
    },
    toComment () {
      // this.$refs.comment.stopScroll()
      // this.setInterface(false)
      // this.util.panoInter(false)
      this.commentInputShow = !this.commentInputShow
    },
    // 展馆信息
    showMuseumInfo (boo) {
      this.setInterface(!boo)
      this.util.panoInter(!boo)
      this.museumInfoShow = boo
    },
    // 分享盒子展示
    setShowShare () {
      this.isShowShare = !this.isShowShare
    },
    showHonor (boo) {
      this.setInterface(!boo)
      this.util.panoInter(!boo)
      this.honorShow = boo
    },
    showModel (boo) {
      this.setInterface(!boo)
      this.util.panoInter(!boo)
      this.markerInfo.display = boo
    },
    setPanoIntroShowAll (boo) {
      this.setInterface(!boo)
      this.util.panoInter(!boo)
      this.panoIntroShowAll = boo
    },
    toOfficialWeb () {
      location.href = 'http://m.vizen.cn/#/'
    },
    todoRoaming (i) {
      this.$refs.panoListLine[i].style.width = 0
      this.isRoaming = true

      let temp = () => {
        let thisId = this.panoGroup[i]
        let time = parseInt(this.allPano[thisId].baseInfo.qrCodeName || 5)
        this.setPanoListLineWidth(time, i)
        this.roamingTime = setTimeout(() => {
          if (this.panoGroup[i + 1]) {
            this.todoRoaming(i + 1)
          } else {
            this.stopRoaming()
          }
        }, time * 1000)
      }

      if (i < this.panoGroup.length) {
        if (this.curPano.id === this.panoGroup[i]) {
          temp()
        } else {
          this.setPano(this.panoGroup[i], null, null, () => {
            setTimeout(() => {
              temp()
            }, 500)
          })
        }
      }
    },
    setPanoListLineWidth (time, i) {
      let step = 0
      let per = 100 / time
      clearInterval(this.panoListLineInter)
      this.panoListLineInter = setInterval(() => {
        if (per * step >= 100) {
          clearInterval(this.panoListLineInter)
        } else {
          step++
          this.$refs.panoListLine[i].style.width = per * step + '%'
        }
      }, 1000)
    },
    stopRoaming () {
      if (this.roamingTime) {
        clearTimeout(this.roamingTime)
      }
      if (this.panoListLineInter) {
        clearInterval(this.panoListLineInter)
      }
      this.isRoaming = false
    },
    closeImageFullScreen () {
      this.imageSwiperList = []
      this.imageFullscreen = false
    },
    showImagePage (plugin) {
      this.setInterface(false)
      this.util.panoInter(false)
      this.markerInfo.info = plugin
      this.markerInfo.display = true
    },
    closeImagePage () {
      this.markerInfo.display = false
      setTimeout(() => {
        this.setInterface(true)
        this.util.panoInter(true)
      }, 800)
    },
    toPanoPage (id) {
      // this.closeMapFullscreen()
      this.setPano(id)
    },
    shareTo (type) {
      let img = ''
      let title = ''
      let content = ''

      // 获取分享标题
      title = this.appInfo.shareTitle
      // 获取分享内容
      content = this.appInfo.shareDesc
      // 获取网页中内容的第一张图片
      img = this.appInfo.logo || this.appInfo.thumbnail

      // 新浪微博接口的传参
      if (type === 'wb') {
        this.whichShareBtnSelect = type
        window.open('http://service.weibo.com/share/share.php?url=http://t.cn/AiW4llWs&shareTitle=' + title + '&shareDesc=' + content + '&thumbnail=' + img + '')
        // window.open('http://service.weibo.com/share/share.php?url=' + encodeURIComponent(location.href) + '&shareTitle=' + title + '&shareDesc=' + content + '&thumbnail=' + img + '')
        return false
      }

      // qq接口的传参
      if (type === 'qq') {
        this.whichShareBtnSelect = type
        window.open('https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + location.href + '&sharesource=qzone&title=' + title + '&pics=' + img + '&summary=' + content + '')
        return false
      }

      // 生成二维码给微信扫描分享
      if (type === 'wx') {
        if (this.whichShareBtnSelect === 'wx') {
          this.whichShareBtnSelect = ''
        } else {
          this.whichShareBtnSelect = type
        }
      }
    },
    showBuyAlertPage (pic) {
      this.buyPageQRCode = pic
      this.util.panoInter(false)
      this.setInterface(false)
      this.buyPageShow = true
    },
    closeBuyPage () {
      this.buyPageQRCode = ''
      this.buyPageShow = false
      this.util.panoInter(true)
      this.setInterface(true)
    },
    showSearchPage () {
      this.searchPageShow = true
    }
  }
}
</script>

<style lang="scss">
  @function rem($px) {
    @return $px*(1/40)*1rem;
  }
  $animationTime: 0.6s;

  @keyframes pulse {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }

    20% {
      -webkit-transform: scale3d(1.2, 1.2, 1.2);
      transform: scale3d(1.2, 1.2, 1.2);
    }
    50% {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }

    75% {
      -webkit-transform: scale3d(1.2, 1.2, 1.2);
      transform: scale3d(1.2, 1.2, 1.2);
    }

    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }

  @font-face{
    font-family: 'SemiBold';
    src: url('../assets/font/SemiBold.otf') format('truetype');
  }

  .pano-change-marker > div{
    cursor: pointer;
    transition: transform 0.3s;
    transform-origin: center center !important;
    &:hover{
      transform: scale3d(1.2, 1.2, 1);
    }
  }

  /*空间切换类marker样式*/
  .movingArrowRight {
    background-image: url('../assets/img/marker/right-marker-arrow.png');
    background-position: 0 0;
    background-size: 100% auto;
    -webkit-animation: movingArrowRightkey infinite steps(27) 1000ms;
    animation: movingArrowRightkey infinite steps(27) 1000ms;
  }

  @keyframes movingArrowRightkey {
    0% {
      background-position: 0 1080px;
    }
    100% {
      background-position: 0 0;
    }
  }

  .movingArrowDown {
    background-image: url('../assets/img/marker/up-marker-arrow.png');
    background-position: 0 0;
    background-size: 100% auto;
    -webkit-animation: movingArrowDownkey infinite steps(27) 1000ms;
    animation: movingArrowDownkey infinite steps(27) 1000ms;
  }

  @keyframes movingArrowDownkey {
    0% {
      background-position: 0 972px;
    }
    100% {
      background-position: 0 0;
    }
  }

  .movingArrowLeft {
    background-image: url('../assets/img/marker/left-marker-arrow.png');
    background-position: 0 0;
    background-size: 100% auto;
    -webkit-animation: movingLeftDownkey infinite steps(27) 1000ms;
    animation: movingLeftDownkey infinite steps(27) 1000ms;
  }

  @keyframes movingLeftDownkey {
    0% {
      background-position: 0 1080px;
    }
    100% {
      background-position: 0 0;
    }
  }

  .movingNormal {
    // background-image: url('../assets/img/marker/marker-normal.png');
    // background-position: 0 0;
    // background-size: 100% 100%;
    // -webkit-animation: movingNormalkey infinite 1000ms;
    // animation: movingNormalkey infinite 1000ms;
  }

  @keyframes movingNormalkey {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(5px);
    }
    100% {
      transform: translateY(0);
    }
  }
  .qr-wrap {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.267);
    width: 100vw;
    height: 100vh;
    z-index: 999;
    .qr-box {
      position: absolute;
      left:50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: rem(412);
      height: rem(515);
      z-index: 999;
      img {
        width: 100%;
      }
      .close {
        position: absolute;
        right: 0;
        top: 0;
        width: rem(40);
        height: rem(40);
        cursor: pointer;
      }
    }
  }
  /*marker样式*/
  .marker-line {
    font-size: 0;
    line-height: 0;
    cursor: pointer;
    transition: transform 0.3s;
    transform-origin: center bottom;
    &.info {
      img {
        margin-left: 34px;
        width: 45px;
        height: 45px;
        border: 1px solid #FFFFFF;
        border-radius: 5px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
      }
    }
    &.big {
      &:hover{
        transform: scale3d(1.1, 1.1, 1);
      }
      .title {
        width: 118px;
        height: 50px;
        background:rgba(22,77,55,0.8);
        font-size:18px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(255,255,255,1);
        line-height:50px;
        letter-spacing:2px;
        text-align: center;
        border-radius: 10px;
      }
      .bottom {
        width: 30px;
        height: 10px;
        background: url('../assets/img/pc/info-bottom.png') no-repeat scroll center center/cover content-box content-box;
        margin: 4px auto 0;
      }
    }
    &.small {
      &:hover{
        transform: scale3d(1.1, 1.1, 1);
      }
      .title {
        width: 69px;
        font-family: PingFangSC-Regular;
        font-size: 10px;
        line-height: 14px;
        color: #FFFFFF;
        letter-spacing: 1px;
        text-align: center;
        text-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
        margin-bottom: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    &.video{
      width: 164px;
      height: 105px;
      border-radius: 3px;
      overflow: hidden;
      position: relative;
      background: url('../assets/img/pc/video-top.png') no-repeat scroll center center/cover content-box content-box;
      &:hover{
        transform: scale3d(1.1, 1.1, 1);
      }
      img{
        width: 120px;
        height: 68px;
        border-radius: 3px;
        position: absolute;
        width: 115px;
        height: 59px;
        border-radius: 3px;
        position: absolute;
        left: 25px;
        top: 23.5px;
      }
    }
    .img-box {
      position: relative;
      margin-left: 34px;
      width: 45px;
      height: 45px;
      img {
        margin: 0;
      }
      .icon {
        position: absolute;
        width: rem(24);
        height: rem(24);
        right: rem(-8);
        top:  rem(-8);
        box-shadow: none;
        margin: 0;
        background: none;
        border: none;
      }
    }
  }
  .video-bottom {
    width: 99px;
    height: 29px;
    background: url('../assets/img/pc/video-bottom.png') no-repeat scroll center center/cover content-box content-box;
    margin: auto;
    margin-top: -23px;
  }

  /*界面样式*/
  .card-cover{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(4,20,32,0.6);
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .close-btn{
      width: rem(47);
      height: rem(47);
      background: url("../assets/img/mobile/icon-close.png") no-repeat 0 0;
      background-size: rem(47) rem(47);
      position: absolute;
      right: rem(50);
      top: rem(50);
      cursor: pointer;
    }
    .title{
      width: rem(250);
      height: rem(48);
      background: url("../assets/img/mobile/main-logo.png") no-repeat 0 0;
      background-size: rem(250) rem(48);
      position: absolute;
      left: rem(50);
      top: rem(40);
    }
    .timeline{
      height: rem(48);
      position: absolute;
      left: 50%;
      bottom: rem(80);
      transform: translateX(-50%);
      li{
        float: left;
        margin-right: rem(120);
        width: rem(10);
        height: rem(10);
        position: relative;
        &:nth-last-of-type(1){
          margin-right: 0;
        }
        &::before{
          content: ' ';
          width: rem(8);
          height: rem(8);
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 50%;
          border: 1px solid #ffffff;
        }
        &::after{
          content: ' ';
          width: rem(120);
          height: 0;
          border-bottom: 1px dotted #ffffff;
          position: absolute;
          left: rem(10);
          top: rem(4);
        }
        &:nth-last-of-type(1):after{
          display: none;
        }
      }
      p{
        font-family: PingFangSC-Regular;
        font-size: rem(17);
        line-height: rem(24);
        color: #FFFFFF;
        letter-spacing: rem(1);
        text-align: justify;
        position: absolute;
        left: 50%;
        top: rem(24);
        transform: translateX(-50%);
        white-space: nowrap;
      }
    }
  }

  .main-cover{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(4,20,32,0.6);
    z-index: 11;
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .box{
      width: rem(1244);
      height: rem(700);
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: rem(-622);
      margin-top: rem(-350);
      font-size: 0;
    }
    .video-box{
      width: rem(1244);
      height: rem(700);
      video{
        width: rem(1244);
        height: rem(700);
        background: #000000;
      }
    }
    .box-image-swiper{
      width: rem(1200);
      height: rem(800);
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: rem(-600);
      margin-top: rem(-400);
      font-size: 0;
    }
    .image-swiper-box{
      width: rem(1200);
      height: rem(800);
      img{
        width: rem(1200);
        height: rem(800);
      }
      .swiper-button-prev {
        width: rem(55);
        height: rem(55);
        background: url("../assets/img/pc/icon-expand.png") no-repeat 0 0;
        background-size: rem(55) rem(55);
        cursor: pointer;
        z-index: 100;
        transform: rotateZ(180deg);
        &:hover {
          background: url("../assets/img/pc/icon-expand-hover.png") no-repeat 0 0;
          background-size: rem(55) rem(55);
        }
      }
      .swiper-button-next{
        width: rem(55);
        height: rem(55);
        background: url("../assets/img/pc/icon-expand.png") no-repeat 0 0;
        background-size: rem(55) rem(55);
        cursor: pointer;
        z-index: 100;
        &:hover {
          background: url("../assets/img/pc/icon-expand-hover.png") no-repeat 0 0;
          background-size: rem(55) rem(55);
        }
      }
      .swiper-pagination-bullet-active{
        background: #FCD187;
      }
    }
    .iframe-box{
      width: rem(1244);
      height: rem(700);
      iframe{
        background: #ffffff;
        width: rem(1244);
        height: rem(700);
      }
    }
    .close-btn{
      width: rem(44);
      height: rem(44);
      background: url("../assets/img/pc/icon-close.png") no-repeat rem(10) rem(10);
      background-size: rem(24) rem(24);
      position: fixed;
      right: rem(20);
      top: rem(20);
      border-radius: 50%;
      cursor: pointer;
      background-color:rgba(0,0,0,0.3);
      z-index: 11;
    }
  }
  .top-cover {
    height: rem(89);
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0.40) 0%, rgba(0,0,0,0.00) 100%);
    transform: translateY(0);
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateY(rem(-89));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
    .join-btn {
      font-size:rem(14);
      color:rgba(255,255,255,1);
      position: absolute;
      right: rem(126);
      top: rem(40);
    }
    .buy-btn {
      font-size:rem(14);
      color:rgba(255,255,255,1);
      position: absolute;
      right: rem(40);
      top: rem(40);
    }
    .join-btn, .buy-btn{
      &::after{
        display: none;
        content: ' ';
        font-size: rem(14);
        line-height: rem(20);
        padding: rem(5) rem(20);
        color: #ffffff00;
        background: rgba(0,0,0,0);
        border-radius: rem(4);
        white-space: nowrap;
        position: absolute;
        right: 0;
        bottom: rem(-35);
      }
      &.wait-alert:hover{
        &::after{
          display: block;
        }
      }
    }
    .back-btn {
      width: rem(80);
      height: rem(24);
      line-height: rem(24);
      font-size:rem(14);
      color:rgba(255,255,255,1);
      position: absolute;
      left: rem(70);
      top: rem(40);
      display: flex;
      align-items: center;
      img {
        display: flex;
        width: rem(24);
        height: rem(24);
      }
      span {
        height: rem(24);
        line-height: rem(24);
        font-size:rem(14);
        line-height: rem(24);
        display: block;
        margin-left: rem(5);
      }
    //   position: relative;
    //   &::before {
    //     position: absolute;
    //     content: ' ';
    //     width: rem(24);
    //     height: rem(24);
    //     left: rem(-30);
    //     letter-spacing: rem(1);
    //     background:
    //       url('../assets/img/pc/home.png')
    //       no-repeat
    //       scroll
    //       center center / cover
    //       content-box content-box;
    //   }
    }
  }
  .bottom-cover {
    height: rem(100);
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, rgba(9,9,10,0.00) 5%, rgba(9,9,10,0.33) 100%);
    transform: translateY(0);
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateY(rem(100));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
  }
  .right-cover {
    width: rem(346);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    background-image: linear-gradient(90deg, rgba(9,9,10,0.00) 5%, rgba(9,9,10,0.83) 100%);
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateX(rem(346));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
  }
  .right-info-box {
    position: absolute;
    top: rem(140);
    right: rem(40);
    width: rem(400);
    min-height: rem(430);
    height: rem(630);
    overflow: hidden;
    transform: translateX(0);
    background:rgba(22,77,55,0.6);
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateX(rem(450));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
    .right-info {
      margin: rem(60) rem(30) rem(30) rem(30);
    }
    .name-box,.audio-box,.text-box,.btn-box {
      width: rem(340);
    }
    .name-box {
      // margin-top: rem(50);
      height:rem(56);
      font-size:rem(40);
      font-weight:600;
      color:rgba(244,252,249,1);
      line-height:rem(56);
    }
    .audio-box {
      margin-top: rem(18);
      height:rem(44);
      font-weight:600;
      background:rgba(255,255,255,0.1);
      border-radius:rem(2);
      display: flex;
      align-items: center;
      justify-content: center;
      .aduio-item {
        width: rem(300);
        height: rem(24);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .audio-btn {
          width: rem(24);
          height: rem(24);
          background: url('../assets/img/pc/audio-play.png') no-repeat scroll center center/cover content-box content-box;
          &.playing {
            background-image: url('../assets/img/pc/audio-playing.png');
          }
        }
        .audio-time {
          font-size:rem(12);
          font-weight:400;
          color:rgba(255,255,255,1);
          span:last-child {
            color:rgba(255,255,255,0.7);
          }
        }
        .audio-progress {
          width: rem(176);
          height:4px;
          background:rgba(255,255,255,0.2);
          border-radius:rem(4);
          .audio-progress-inner {
            width: 0;
            height:4px;
            background:rgba(255,255,255,1);
            border-radius:rem(4);
          }
        }
      }
    }
    .text-box {
      position: absolute;
      bottom: rem(100);
      top: rem(213-44-18);
      font-size:rem(18);
      font-weight:400;
      color:rgba(244,252,249,1);
      line-height:rem(27);
      p {
        font-size: rem(18);
      }
    }
    .btn-box {
      position: absolute;
      bottom: rem(30);
      height: rem(54);
      // margin-top: rem();
      font-size:rem(18);
      font-weight:400;
      color:rgba(244,252,249,1);
      line-height:rem(54);
      background:rgba(255,255,255,0.1);
      text-align: center;
      color:rgba(244,252,249,1);
      // margin-bottom: rem(30);
    }
    .btn-back-box{
      width: rem(100);
      position: absolute;
      left: rem(30);
      bottom: rem(30);
    }
    .btn-next-box{
      width: rem(230);
      position: absolute;
      left: auto;
      right: rem(30);
      bottom: rem(30);
    }
  }
  .logo-box {
    position: absolute;
    left: rem(50);
    top: rem(40);
    transform: translateY(0);
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateY(rem(-90));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
    .logo {
      float: left;
      width: rem(88);
      height: rem(40);
      background: url("../assets/img/mobile/main-logo.png") no-repeat 0 0;
      background-size: 100%;
    }
    span {
      float: left;
      display: block;
      width: 1px;
      height: rem(40);
      background: url("../assets/img/mobile/logo-line.png") no-repeat center center;
      background-size: 1px rem(40);
      margin-left: rem(12);
    }
    .visit-num{
      float: left;
      font-family: PingFangSC-Regular;
      font-size: rem(18);
      line-height: rem(40);
      color: #FFFFFF;
      letter-spacing: rem(1);
      margin-left: rem(46);
      position: relative;
      &::before{
        content: ' ';
        display: block;
        width: rem(22);
        height: rem(16);
        position: absolute;
        top: rem(12);
        left: rem(-28);
        background: url("../assets/img/mobile/icon-visit-color.png") no-repeat 0 0;
        background-size: rem(22) rem(16);
      }
    }
    .name{
      float: left;
      font-family: PingFangSC-Regular;
      font-size: rem(16);
      line-height: rem(24);
      color: #FFFFFF;
      letter-spacing: rem(1);
      text-shadow: 0 2px 4px rgba(4,20,32,0.30);
      margin-left: rem(20);
      margin-top: rem(10);
    }
  }
  .map-box{
    width: rem(144);
    height: rem(144);
    position: absolute;
    left: rem(26);
    top: rem(122);
    border-radius: 50%;
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateX(rem(-170));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
    &:hover{
      .back{
        animation: mapHover 3s infinite;
      }
    }
    .back{
      width: rem(144);
      height: rem(144);
      position: absolute;
      left: 0;
      top: 0;
      border-radius: 50%;
      background: rgba(238,238,238,0.14);
      opacity: 1;
    }

    .map-back{
      width: rem(128);
      height: rem(128);
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      background-color: rgba(41, 47, 66, 0.5) ;
      overflow: hidden;
      border-radius: 50%;
      .map{
        position: absolute;
        left: rem(0);
        top: rem(0);
        width: rem(128);
        height: rem(128);
        background-image: url("../assets/img/mobile/map-total.png");
        background-size: rem(128) rem(128);
      }
      .radar-box{
        position: absolute;
        left: rem(64);
        top: rem(64);
      }
      .radar {
        width: rem(65);
        height: rem(55);
        position: absolute;
        left: rem(-33);
        top: rem(-55);
        transform: rotateZ(0);
        transform-origin: center bottom;
        &::after{
          content: ' ';
          display: block;
          width: rem(65);
          height: rem(55);
          position: absolute;
          left: 0;
          top: 0;
          background: url("../assets/img/mobile/map-radar-big.png") no-repeat 0 0;
          background-size: rem(65) rem(55);
        }
      }
      .circle{
        width: rem(16);
        height: rem(16);
        position: absolute;
        left: rem(-8);
        top: rem(-8);
        background: url("../assets/img/mobile/map-circle-big.png") no-repeat 0 0;
        background-size: rem(16) rem(16);
        z-index: 2;
      }
    }
  }
  .left-btn{
    width: rem(40);
    height: rem(40);
    border:2px solid rgba(255,255,255,0.3);
    border-radius: 50%;
    position: absolute;
    left: rem(70);
    top: rem(136);
    cursor: pointer;
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateX(rem(-120));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
    .btn-box{
      width: rem(40);
      height: rem(40);
      background:rgba(22,77,55,0.6);
      position: absolute;
      left: 0;
      top: 0;
      border-radius: 50%;
    }
    .music{
      width: rem(24);
      height: rem(24);
      background: url("../assets/img/pc/icon-music-small.png") no-repeat 0 0;
      background-size: 100% 100%;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: rem(-12);
      margin-top: rem(-12);
      &.selected{
        animation: musicRotate 5s linear infinite;
      }
    }
  }

  .bottom-btn-box {
    position: absolute;
    left: rem(50);
    bottom: rem(48);
    z-index: 12;
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateY(rem(90));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
    .btn-box {
      float: left;
      height: rem(40);
      .btn {
        width: rem(40);
        height: rem(40);
        margin-right: rem(15);
        position: relative;
        cursor: pointer;
        .num{
          font-family: PingFangSC-Regular;
          font-size: rem(11);
          line-height: rem(14);
          color: #FFFFFF;
          text-align: center;
          width: 100%;
          position: absolute;
          left: 0;
          bottom: rem(-15);
        }
        .icon {
          display: block;
          width: rem(40);
          height: rem(40);
          &.album {
            background: url("../assets/img/pc/icon-album.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          &.fullscreen {
            background: url("../assets/img/pc/icon-fullscreen.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          &.like {
            background: url("../assets/img/pc/icon-like.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          &.share {
            background: url("../assets/img/pc/icon-share.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          &.music {
            background: url("../assets/img/pc/icon-music.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          &.info {
            background: url("../assets/img/pc/icon-info.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          &.comment {
            background: url("../assets/img/pc/icon-comment.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
        }
        &:hover, &.selected {
          .album {
            background: url("../assets/img/pc/icon-album-color.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          .fullscreen {
            background: url("../assets/img/pc/icon-fullscreen-color.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          .like {
            background: url("../assets/img/pc/icon-like-color.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          .share {
            background: url("../assets/img/pc/icon-share-color.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          .music {
            background: url("../assets/img/pc/icon-music-color.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          .info {
            background: url("../assets/img/pc/icon-info-color.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          .comment {
            background: url("../assets/img/pc/icon-comment-color.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
        }
        &.selected{
          .music {
            animation: musicRotate 5s linear infinite;
          }
        }
        &:hover {
          .tip {
            display: block;
          }
        }
        .tip {
          display: none;
          padding: 0 rem(12);
          font-family: PingFangSC-Regular;
          font-size: rem(12);
          line-height: rem(26);
          color: #FFFFFF;
          letter-spacing: 1px;
          text-align: center;
          background: rgba(4, 20, 32, 0.7);
          border-radius: rem(4);
          position: absolute;
          left: 50%;
          top: rem(-34);
          transform: translateX(-50%);
          white-space: nowrap;
          &::before {
            content: ' ';
            display: block;
            width: 0;
            height: 0;
            border-width: rem(8) rem(6) 0;
            border-style: solid;
            border-color: rgba(4, 20, 32, 0.7) transparent transparent;
            position: absolute;
            left: 50%;
            bottom: rem(-8);
            transform: translateX(-50%);
          }
        }
      }
    }
    .only-one-btn{
      padding: 0;
      margin-left: rem(30);
    }
  }

  .share-box{
    width: rem(240);
    position: absolute;
    left: 50%;
    bottom: rem(80);
    transform: translateX(-50%);
    &.opacity-enter, &.opacity-leave-to {
      opacity: 0;
    }
    &.opacity-enter-active, &.opacity-leave-active {
      transition: opacity $animationTime;
    }
    .qrcode-box{
      width: rem(240);
      height: rem(244);
      margin-bottom: rem(12);
      background: rgba(4, 20, 32, 0.9);
      border-radius: rem(4);
      text-align: center;
      .share-wx{
        width: 100%;
        font-family: PingFangSC-Regular;
        font-size: rem(15);
        line-height: rem(20);
        color: #FFFFFF;
        letter-spacing: rem(3);
        padding-top: rem(18);
        margin-bottom: rem(21);
      }
      .qrcode{
        display: inline-block;
        width: rem(116);
        height: rem(116);
        background: rgba(255,255,255,0.28);
        border-radius: rem(4);
        position: relative;
        margin-bottom: rem(20);
        canvas{
          width: rem(100);
          height: rem(100);
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
        }
      }
      .share-tip{
        width: 100%;
        font-family: PingFangSC-Regular;
        font-size: rem(12);
        line-height: rem(18);
        color: #FFFFFF;
        letter-spacing: rem(1.4);
      }
    }
    .share-btn-box{
      width: rem(240);
      height: rem(74);
      background: rgba(4, 20, 32, 0.9);;
      border-radius: rem(4);
      padding-top: rem(18);
      &::before {
        content: ' ';
        display: block;
        width: 0;
        height: 0;
        border-width: rem(8) rem(6) 0;
        border-style: solid;
        border-color: rgba(4, 20, 32, 0.9) transparent transparent;
        position: absolute;
        left: rem(114);
        bottom: rem(-8);
      }
      .share-btn{
        float: left;
        width: rem(40);
        height: rem(62);
        margin: 0 rem(16);
        &:nth-of-type(1){
          margin-left: rem(24);
        }
        div{
          width: rem(40);
          height: rem(40);
          margin-bottom: rem(6);
        }
        p{
          font-family: PingFangSC-Regular;
          font-size: rem(11);
          line-height: rem(16);
          color: #FFFFFF;
          letter-spacing: rem(1.8);
          text-align: center;
        }
        .wx{
          background: url("../assets/img/pc/icon-wx.png") no-repeat 0 0;
          background-size: rem(40) rem(40);
        }
        .qq{
          background: url("../assets/img/pc/icon-qq.png") no-repeat 0 0;
          background-size: rem(40) rem(40);
        }
        .wb{
          background: url("../assets/img/pc/icon-wb.png") no-repeat 0 0;
          background-size: rem(40) rem(40);
        }
        &:hover{
          .wx{
            background: url("../assets/img/pc/icon-wx-hover.png") no-repeat 0 0;
            background-size: rem(40) rem(40);
          }
          .qq{
            background: url("../assets/img/pc/icon-qq-hover.png") no-repeat 0 0;
            background-size: rem(40) rem(40);
          }
          .wb{
            background: url("../assets/img/pc/icon-wb-hover.png") no-repeat 0 0;
            background-size: rem(40) rem(40);
          }
        }
        &.selected{
          .wx{
            background: url("../assets/img/pc/icon-wx-hover.png") no-repeat 0 0;
            background-size: rem(40) rem(40);
          }
          .qq{
            background: url("../assets/img/pc/icon-qq-hover.png") no-repeat 0 0;
            background-size: rem(40) rem(40);
          }
          .wb{
            background: url("../assets/img/pc/icon-wb-hover.png") no-repeat 0 0;
            background-size: rem(40) rem(40);
          }
        }
      }
    }
  }

  .pano-list-area{
    position: absolute;
    top: rem(50);
    bottom: rem(50);
    right: rem(395);
    width: rem(100);
    z-index: 1;
    transform: translateX(rem(475));
    transition: transform $animationTime;
    &.show{
      transform: translateX(0);
    }
    &.pano-change{
      transform: translateX(rem(385));
    }
    .show-all-background{
      width: 100%;
      height: rem(110);
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
  .swiper-box{
    position: absolute;
    top: rem(80);
    left: 0;
    width: rem(100);
  }
  .autoplay-btn{
    width: rem(60);
    height: rem(60);
    background: url("../assets/img/mobile/roaming-play.png") no-repeat 0 0;
    background-size: rem(60) rem(60);
    border-radius: 50%;
    position: absolute;
    left: rem(20);
    top: 0;
    cursor: pointer;
    &.pause{
      background: url("../assets/img/mobile/roaming-pause.png") no-repeat 0 0;
      background-size: rem(60) rem(60);
    }
  }
  .pano-list-box{
    width: rem(100);
    position: relative;
    ul{
      /*padding-top: rem(15);*/
      /*padding-left: rem(11);*/
      li{
        margin-left: rem(20);
        width: rem(60);
        height: rem(60);
        position: relative;
        margin-top: rem(10);
        margin-bottom: rem(10);
        cursor: pointer;
      }
    }
    .img-box{
      position: absolute;
      left: 0;
      top: 0;
      width: rem(60);
      height: rem(60);
      transition: transform 0.3s;
      font-size: 0;
      &:hover{
        transform: scale3d(1.1, 1.1, 1);
      }
      &.selected{
        transform: scale3d(1.1, 1.1, 1);
        .btn-title{
          display: block;
        }
        .border{
          background: rgba(0,0,0,0.7);
          border: 2px solid #FCD187;
        }
      }
    }
    img{
      width: rem(60);
      height: rem(60);
      border-radius: 50%;
    }
    .btn-title{
      display: none;
      font-family: SemiBold;
      width: rem(60);
      line-height: 16px;
      font-size: 12px;
      text-align: center;
      color: #FCD187;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
    }
    .border{
      position: absolute;
      left: 0;
      top: 0;
      box-sizing: border-box;
      width: rem(60);
      height: rem(60);
      border-radius: 50%;
      border: 2px solid #ffffff;
    }
    .selected-btn{
      width: rem(22);
      height: rem(7);
      background: url("../assets/img/mobile/icon-list-focus.png") no-repeat 0 0;
      background-size: rem(22) rem(7);
      position: absolute;
      left: 50%;
      top: rem(-14);
      transform: translateX(-50%);
    }
    .progress-box{
      width: rem(40);
      height: 2px;
      border-radius: 1px;
      background: rgba(255,255,255,0.3);
      position: absolute;
      left: 50%;
      bottom: rem(-10);
      transform: translateX(-50%);
      overflow: hidden;
      .line{
        width: 0;
        height: 100%;
        background: #FCD187;
        transition-property: width;
        transition-timing-function: linear;
      }
    }
  }
  .pano-intro-card{
    position: absolute;
    bottom: rem(94);
    left: 0;
    width: 100%;
    height: rem(90);
    z-index: 6;
    &.fullscreen{
      top: rem(22);
    }
    &.opacity-enter, &.opacity-leave-to {
      opacity: 0;
    }
    &.opacity-enter-active, &.opacity-leave-active {
      transition: opacity $animationTime;
    }
    .card-background{
      position: absolute;
      left: rem(26);
      right: rem(26);
      top: 0;
      bottom: 0;
      transform: translateY(0);

      .title-box{
        position: relative;
        display: inline-block;
        height: rem(40);
        max-width: rem(264);
      }
      h2{
        font-family: SemiBold;
        font-size: rem(18);
        color: #FBE58D;
        letter-spacing: rem(1.5);
        height: rem(26);
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap
      }
      h3{
        font-family: SemiBold;
        font-size: rem(10);
        color: #FBE58D;
        letter-spacing: rem(1);
        height: rem(14);
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap
      }
      .audio-btn{
        width: rem(30);
        height: rem(30);
        position: absolute;
        right: rem(-40);
        top: rem(5);
        overflow: hidden;
        img{
          width: rem(90);
          height: rem(30);
          transform: translateX(rem(-60));
        }
        .playing{
          animation: audioPlaying 1.5s forwards steps(3) infinite;
        }
      }
      p{
        width: 100%;
        height: rem(42);
        font-size: rem(12);
        color: #FFFFFF;
        letter-spacing: rem(1);
        line-height: rem(22);
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .updown-btn{
        display: block;
        width: rem(30);
        height: rem(30);
        position: absolute;
        right: 0;
        top: rem(5);
        background: url("../assets/img/mobile/icon-down.png") no-repeat center center;
        background-size: rem(15) rem(15);
        transform: rotateZ(180deg);
      }
    }
  }
  .brand-btn{
    width: rem(54);
    height: rem(39);
    position: absolute;
    right: 0;
    bottom: rem(194);
    background: url("../assets/img/mobile/logo-btn.png") no-repeat 0 0;
    background-size: rem(54) rem(39);
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateX(rem(54));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
  }

  /*公司简介样式*/
  .brand-cover{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(21,0,0,0.8);
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .logo{
      width: rem(47);
      height: rem(47);
      position: absolute;
      left: 50%;
      top: rem(55);
      background: url("../assets/img/mobile/brand-logo.png") no-repeat 0 0;
      background-size: rem(47) rem(47);
      transform: translateX(-50%);
    }
    .intro{
      width: rem(312);
      position: absolute;
      left: 50%;
      top: rem(124);
      transform: translateX(-50%);
      border-top: 1px solid rgba(255,255,255,0.5);
      p{
        font-family: PingFangSC-Light;
        font-size: rem(14);
        color: #ffffff;
        letter-spacing: rem(1);
        line-height: rem(24);
      }
    }
    .official-web-btn{
      width: rem(159);
      height: rem(34);
      position: absolute;
      left: rem(28);
      top: rem(477);
      background: url("../assets/img/mobile/btn-official-web.png") no-repeat 0 0;
      background-size: rem(159) rem(34);
    }
    .contact-us-btn{
      width: rem(159);
      height: rem(34);
      position: absolute;
      right: rem(28);
      top: rem(477);
      background: url("../assets/img/mobile/btn-contact-us.png") no-repeat 0 0;
      background-size: rem(159) rem(34);
    }
    .close-btn{
      width: rem(47);
      height: rem(47);
      background: url("../assets/img/mobile/icon-close.png") no-repeat 0 0;
      background-size: rem(47) rem(47);
      position: absolute;
      right: rem(50);
      top: rem(50);
      cursor: pointer;
    }
  }

  /*展览介绍样式*/
  .museum-cover{
    position: absolute;
    left: 50%;
    top: 50%;
    width: rem(1140);
    height: rem(778);
    margin-left: rem(-570);
    margin-top: rem(-389);
    background: rgba(5, 59, 87, 0.9);

    background-size: 100% 100%;
    font-size: 0;
    border-radius: rem(5);
    overflow: hidden;
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .area{
      position: absolute;
      left: 0;
      top: 0;
      right: rem(30);
      bottom: 0;
    }
    .box{
      width: rem(460);
      height: auto;
      margin-left: rem(340);
      margin-bottom: rem(50);
      text-align: center;
    }
    .logo{
      display: inline-block;
      width: rem(404);
      height: rem(182);
      background: url("../assets/img/mobile/guobo-logo.png") no-repeat 0 0;
      background-size: cover;
      margin-top: rem(140);
      margin-bottom: rem(10);
    }
    .intro{
      width: 100%;
      li{
        margin-bottom: rem(30);
        padding: 0 rem(20);
      }
      h3{
        font-family: SemiBold;
        font-size: rem(19);
        color: #fff;
        letter-spacing: rem(1);
        text-align: center;
        line-height: rem(35);
      }
      h4{
        font-family: SemiBold;
        font-size: rem(16);
        color: #fff;
        letter-spacing: rem(1);
        text-align: center;
        line-height: rem(35);
      }
    }
    .official-web-btn{
      width: rem(159);
      height: rem(34);
      position: absolute;
      left: rem(28);
      top: rem(477);
      background: url("../assets/img/mobile/btn-official-web.png") no-repeat 0 0;
      background-size: rem(159) rem(34);
    }
    .contact-us-btn{
      width: rem(159);
      height: rem(34);
      position: absolute;
      right: rem(28);
      top: rem(477);
      background: url("../assets/img/mobile/btn-contact-us.png") no-repeat 0 0;
      background-size: rem(159) rem(34);
    }
    .close-btn{
      width: rem(26);
      height: rem(26);
      background: url("../assets/img/pc/icon-close.png") no-repeat 0 0;
      background-size: rem(26) rem(26);
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      z-index: 1;
    }
    .swiper-scrollbar-drag{
      background: #FCD187;
    }
  }
  .share-cover{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(21,0,0,0.8);
    z-index: 20;
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    img{
      width: rem(182);
      height: rem(169);
      position: absolute;
      right: rem(34);
      top: rem(5);
    }
    p{
      width: 100%;
      height: rem(18);
      font-family: PingFangSC-Regular;
      font-size: rem(13);
      line-height: rem(18);
      color: #FFFFFF;
      letter-spacing: rem(1);
      text-align: center;
      position: absolute;
      left: 0;
      top: rem(203);
    }
  }
  .full-map-cover{
    overflow: hidden;
    transform: translateX(0);
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateX(rem(-765));
    }
    &.small.moveIn-enter, &.moveIn-leave-to {
      transform: translateX(rem(-240));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
    .bottom-tip{
      width: rem(440);
      height: rem(138);
      background: url("../assets/img/mobile/map-bottom-tip.png") no-repeat 0 0;
      background-size: rem(440) rem(138);
      position: absolute;
      left: 50%;
      bottom: rem(30);
      margin-left: rem(-220);
    }
    .map{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -60%, 0);
      width: rem(440);
      height: rem(710);
      background-image: url("../assets/img/mobile/map-total.png");
      background-size: rem(440) rem(710);
      .radar-box{
        position: absolute;
        left: 0;
        top: 0;
      }
      .radar {
        width: rem(32);
        height: rem(27);
        position: absolute;
        left: rem(-15);
        top: rem(-28);
        transform: rotateZ(0);
        transform-origin: center bottom;
        &::after{
          content: ' ';
          display: block;
          width: rem(32);
          height: rem(27);
          position: absolute;
          left: 0;
          top: 0;
          background: url("../assets/img/mobile/map-radar-big.png") no-repeat 0 0;
          background-size: rem(32) rem(27);
        }
      }
      .circle{
        width: rem(14);
        height: rem(14);
        position: absolute;
        left: rem(-7);
        top: rem(-7);
        background: url("../assets/img/mobile/map-circle-big.png") no-repeat 0 0;
        background-size: rem(14) rem(14);
        z-index: 2;
      }
      .wenwu-box{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .wenwu-mk{
          width: rem(25);
          height: rem(25);
          font-size: 0;
          position: absolute;
          transform: translate3d(rem(-13), rem(-25), 0);
          img{
            width: rem(18);
            height: rem(25);
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: rem(-9);
            margin-top: rem(-12);
            cursor: pointer;
            transition: transform 0.3s;
            transform-origin: center center;
            &:hover{
              transform: scale3d(1.5, 1.5, 1);
            }
          }
        }
        .circle-mk{
          width: rem(14);
          height: rem(14);
          font-size: 0;
          position: absolute;
          transform: translate3d(rem(-7), rem(-7), 0);
          .hover-cover{
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: url("../assets/img/mobile/map-circle-big.png") no-repeat 0 0;
            background-size: rem(14) rem(14);
            cursor: pointer;
            transition: transform 0.3s;
            transform-origin: center center;
            &:hover{
              transform: scale3d(1.5, 1.5, 1);
            }
            &.is-view{
              background: url("../assets/img/pc/map-circle-isview.png") no-repeat 0 0;
              background-size: rem(14) rem(14);
            }
          }
        }
      }
    }
    .close-btn{
      display: block;
      width: rem(25);
      height: rem(25);
      background: url("../assets/img/pc/icon-close.png") no-repeat 0 0;
      background-size: rem(25) rem(25);
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
  }
  .roaming-cover{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
  }

  .pick-btn{
    width: rem(40);
    height: rem(40);
    border: 2px solid rgba(255,255,255,0.2);
    /*background: rgba(255,255,255,0.2);*/
    border-radius: 50%;
    position: absolute;
    left: rem(70);
    top: rem(200);
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateX(rem(-120));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
    // &.selected {
    // animation: pulse 1 1000ms;
    // }
    &.selected2 {
      animation: pulse 1 1000ms;
    }
    cursor: pointer;
    &::before{
      content: ' ';
      width: rem(40);
      height: rem(40);
      background:rgba(22,77,55,0.6);
      position: absolute;
      border-radius: 50%;
    }
    &.selected::before {
      transition: all $animationTime;
      background:linear-gradient(180deg,rgba(196,248,58,1) 0%,rgba(4,164,77,1) 100%);
    }
    .pick{
      width: rem(24);
      height: rem(24);
      background: url("../assets/img/mobile/pick.png") no-repeat 0 0;
      background-size: 100% 100%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .picked-cover {
    width: rem(500);
    /*height: rem(515);*/
    position: absolute;
    left: 50%;
    top: 50%;
    background:#04A44D;
    background-size: 100% 100%;
    z-index: 999;
    transform: translate3d(-50%, -50%, 0);
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .mobile-title {
      height:rem(65);
      border-bottom: rem(1) solid rgba(255, 255, 255, 0.6);
      p {
        height: rem(65);
        line-height: rem(65);
        font-size:rem(14);
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        margin-left: rem(20);
      }
    }
    .body {
      margin-top: rem(20);
      .rows {
        display: flex;
        justify-content: center;
        .item {
          width: rem(100);
          margin-right: 0 rem(10);
          img {
            width: rem(100);
            opacity: 0.2;
          }
          &.select {
            img {
              opacity: 1;
            }
          }
        }
      }
    }
    .text-box {
      font-size:rem(14);
      font-weight:400;
      color:rgba(244,252,249,1);
      margin-top: rem(20);
      text-align: center;
    }
    .btn-box{
      width: rem(310);
      height: rem(44);
      background:rgba(255,255,255,1);
      font-size:rem(13);
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(34,34,34,1);
      line-height:rem(44);
      text-align: center;
      margin: rem(10) auto rem(32);
    }
    .close-btn{
      position: absolute;
      right: rem(20);
      top: rem(20);
      width: rem(24);
      height: rem(24);
      background: url("../assets/img/pc/icon-close.png") no-repeat 0 0/cover ;
      display: inline-block;
    }
  }

  .search-page-cover{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background:rgba(243,253,231,1);
    z-index: 1000;
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .mobile-title {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height:rem(65);
      background: #04A44D;
      p {
        height: rem(65);
        line-height: rem(65);
        font-size:rem(14);
        font-weight:500;
        color:rgba(255,255,255,1);
        margin-left: rem(20);
      }
    }
    .close-btn{
      position: absolute;
      right: rem(20);
      top: rem(20);
      width: rem(24);
      height: rem(24);
      background: url("../assets/img/pc/icon-close.png") no-repeat 0 0/cover ;
      display: inline-block;
      cursor: pointer;
    }
    .scroll-box{
      width: 100%;
      height: 100vh;
      overflow-x: hidden;
      overflow-y: scroll;
      -webkit-overflow-scrolling:touch;
      .banner{
        margin-top: rem(65);
        width: 100%;
      }
      .list{
        display: block;
        width: rem(664);
        margin: rem(20) auto rem(85);
      }
    }
  }

  @keyframes mapHover
  {
    0% {
      transform: scale3d(1,1,1);
      opacity: 1;
    }
    20% {
      transform: scale3d(1.2,1.2,1);
      opacity: 0;
    }
    30% {
      transform: scale3d(0.8,0.8,1);
      opacity: 0;
    }
    60% {
      transform: scale3d(1,1,1);
      opacity: 1;
    }
  }

  @keyframes musicRotate
  {
    0% {
      transform: rotateZ(0deg);
    }
    100% {
      transform: rotateZ(360deg);
    }
  }

  @keyframes audioPlaying {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(rem(-90));
    }
  }

  .loading-box{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 100%;
    z-index: 99;

    .loading-icon-back{
      width: rem(100);
      height: rem(100);
      background: url("../assets/img/mobile/loading-back.png") no-repeat center center;
      background-size: rem(100) rem(100);
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: rem(-50);
      margin-top: rem(-50);

      .loading-icon{
        width: rem(50);
        height: rem(50);
        background: url("../assets/img/mobile/loading.png") no-repeat center center;
        background-size: rem(50) rem(50);
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: rem(-25);
        margin-top: rem(-25);
        -webkit-animation: loadingmove 1s forwards steps(10) infinite;
        animation: loadingmove 1s forwards steps(10) infinite;
      }

      @-webkit-keyframes loadingmove {
        0% { -webkit-transform: rotateZ(0); }
        100% { -webkit-transform: rotateZ(360deg); }
      }

      @keyframes loadingmove {
        0% { transform: rotateZ(0); }
        100% { transform: rotateZ(360deg); }
      }
    }
  }

  .buy-page{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    z-index: 99;
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .qrback{
      width: rem(480);
      height: rem(480);
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: rem(-240);
      margin-top: rem(-240);
      background: url("../assets/img/pc/qr-back.png") no-repeat 0 0;
      background-size: 100% 100%;
      .qrcode{
        width: rem(120);
        height: rem(120);
        position: absolute;
        left: rem(180);
        top: rem(260);
      }
      .close-btn{
        width: rem(24);
        height: rem(24);
        position: absolute;
        right: 0;
        top: rem(-34);
        background: url("../assets/img/pc/icon-close.png") no-repeat 0 0;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
  }
</style>
